import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95aff150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-component" }

import { COLOR_SET, FONT_SIZE, FONT_WEIGHT } from '@/styles/variables'
import { computed } from '@vue/reactivity';


export default /*#__PURE__*/_defineComponent({
  name: 'TextComponent',
  props: {
    size: null,
    mobileSize: null,
    color: null,
    weight: null,
    margin: null,
    mobileMargin: null,
    textDecoration: null,
    textAlign: null,
    width: null,
    mobileWidth: null,
    display: null,
    whiteSpace: null,
    textOverflow: null,
    overflow: null,
    wordBreak: null,
    textIndent: null,
    lineHeight: null,
    mobileColor: null,
    font: null
  },
  setup(__props: any) {

const props = __props as {
  size?: string;
  mobileSize?: string;
  color?: string;
  weight?: string;
  margin?: string;
  mobileMargin?: string;
  textDecoration?: string;
  textAlign?: string;
  width?: string;
  mobileWidth?: string;
  display?: string;
  whiteSpace?: string;
  textOverflow?: string;
  overflow?: string;
  wordBreak?: string;
  textIndent?: string;
  lineHeight?: string;
  mobileColor?: string;
  font?: string;
}

_useCssVars(_ctx => ({
  "51b88828": (_unref(font)),
  "685f0298": (_unref(wordBreak)),
  "8cd10256": (_unref(weight)),
  "34198be6": (_unref(fontSize)),
  "0d297366": (_unref(color)),
  "af5a7bea": (_unref(margin)),
  "753d951a": (_unref(textDecoration)),
  "0e4071c9": (_unref(width)),
  "152fbf4a": (_unref(textAlign)),
  "d8b32ff6": (_unref(display)),
  "77252c3a": (_unref(whiteSpace)),
  "0d3cba28": (_unref(textOverflow)),
  "208b65c2": (_unref(overflow)),
  "7546dbd4": (_unref(textIndent)),
  "49a82c18": (_unref(lineHeight)),
  "2c08ecc0": (_unref(mobileSize)),
  "4e8e438d": (_unref(mobileMargin)),
  "55adb807": (_unref(mobileWidth)),
  "5496b9a4": (_unref(mobileColor))
}))



const weight = computed(() => props.weight || FONT_WEIGHT.regular)
const fontSize = computed(() => props.size || FONT_SIZE.m)
const color = computed(() => props.color || COLOR_SET.gray01)
const margin = computed(() => props.margin || '0')
const textDecoration = computed(() => props.textDecoration || 'none')
const width = computed(() => props.width || 'auto')
const textAlign = computed(() => props.textAlign || 'initial')
const display = computed(() => props.display || 'block')
const whiteSpace = computed(() => props.whiteSpace || 'normal')
const textOverflow = computed(() => props.textOverflow || 'clip')
const overflow = computed(() => props.overflow || 'visible')
const wordBreak = computed(() => props.wordBreak || 'normal')
const textIndent = computed(() => props.textIndent || '0')
const lineHeight = computed(() => props.lineHeight || 'inherit')
const font = computed(() => props.font || 'Spoqa Han Sans Neo')

const mobileSize = computed(() => props.mobileSize || props.size || FONT_SIZE.m)
const mobileMargin = computed(() => props.mobileMargin || props.margin || '0')
const mobileWidth = computed(() => props.mobileWidth || props.width || 'auto')
const mobileColor = computed(() => props.mobileColor || props.color || COLOR_SET.gray01)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})